// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\npre[data-v-4866deaa] {\n  white-space: pre-wrap; /* Ensure the text is wrapped properly */\n  word-wrap: break-word; /* Ensure long words are wrapped properly */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
